const FRENCH_ZIP_CODE_PATTERN = /^\d{5}$/;

export const isCompleteFrenchZipCode = (zipCode) =>
  FRENCH_ZIP_CODE_PATTERN.test(zipCode ? `${zipCode}`.trim() : "");

const syncSelectEmptyState = (select) => {
  select.setAttribute("data-empty", select.value ? "false" : "true");
};

const readPlaceholder = (select) =>
  select.getAttribute("data-placeholder") || "";

export const fillCityOptions = (select, cities, selectedValue) => {
  const doc = select.ownerDocument;
  const list = Array.isArray(cities) ? cities : [];
  select.innerHTML = "";

  const empty = doc.createElement("option");
  empty.value = "";
  empty.hidden = true;
  empty.textContent = readPlaceholder(select);
  select.appendChild(empty);

  for (const city of list) {
    const option = doc.createElement("option");
    option.value = city.value;
    option.textContent = city.label;
    select.appendChild(option);
  }

  const hasSelected =
    Boolean(selectedValue) && list.some((city) => city.value === selectedValue);
  select.value = hasSelected ? selectedValue : "";
  select.disabled = false;
  syncSelectEmptyState(select);
};

const findZipInput = (doc, zipField) => {
  if (!doc || !zipField) return null;
  return doc.querySelector(`[data-field="${zipField}"]`);
};

export const setupCitySelects = (doc, { fetchCities, onCityChange } = {}) => {
  if (!doc) {
    return { refresh: () => undefined, teardown: () => undefined };
  }

  const pairs = [];

  for (const select of doc.querySelectorAll("select[data-city-for]")) {
    const zipField = select.getAttribute("data-city-for");
    const zipInput = findZipInput(doc, zipField);
    if (!zipInput) continue;

    let requestId = 0;
    let lastCompleteZip = "";

    const persistCity = (value) => {
      if (typeof onCityChange === "function") {
        onCityChange(select, value);
      }
    };

    const applyZip = async (zipCode, { notifyClear = true } = {}) => {
      const id = ++requestId;
      const trimmed = zipCode ? `${zipCode}`.trim() : "";
      if (!isCompleteFrenchZipCode(trimmed)) {
        const hadCity = Boolean(select.value);
        const hadOptions = select.options.length > 1;
        if (hadCity || hadOptions) {
          fillCityOptions(select, []);
        } else {
          select.disabled = false;
        }
        if (notifyClear && (hadCity || lastCompleteZip)) {
          persistCity("");
        }
        lastCompleteZip = "";
        return;
      }
      if (typeof fetchCities !== "function") return;
      lastCompleteZip = trimmed;
      const restore =
        select.getAttribute("data-restore-value") || select.value || "";
      let cities = [];
      try {
        cities = await fetchCities(trimmed);
      } catch (_error) {
        if (id !== requestId) return;
        fillCityOptions(select, []);
        return;
      }
      if (id !== requestId) return;
      const previous = select.value;
      fillCityOptions(select, cities, restore);
      if (previous && previous !== select.value) {
        persistCity(select.value);
      }
    };

    const onZipInput = () => {
      select.removeAttribute("data-restore-value");
      applyZip(zipInput.value);
    };

    zipInput.addEventListener("input", onZipInput);
    zipInput.addEventListener("change", onZipInput);
    pairs.push({
      zipInput,
      onZipInput,
      applyZip,
    });
  }

  const refresh = () => {
    for (const pair of pairs) {
      pair.applyZip(pair.zipInput.value, { notifyClear: false });
    }
  };

  refresh();

  return {
    refresh,
    teardown: () => {
      for (const pair of pairs) {
        pair.zipInput.removeEventListener("input", pair.onZipInput);
        pair.zipInput.removeEventListener("change", pair.onZipInput);
      }
    },
  };
};
